/**
 * signInWithPasskey ceremony (Req 11.3)
 *
 * 3 phase: signin-options → bridge.get (navigator.credentials.get) → signin-verify。
 * 成功時、既存 `@auth/client` TokenStorage に access_token / refresh_token を書込む
 * (password login `AuthClient.login` と同一パターン)。
 * ApiClient が HTTP error を `AuthError` として surface するため、ここでは再ラップしない。
 */
import { detectConditionalMediationSupport } from "../feature-detect/browser-support.js";
/**
 * passkey で sign-in し、`LoginResponse` を返す。
 *
 * @param apiClient `@auth/client` の ApiClient (inject 経由)
 * @param webAuthnBridge WebAuthn ceremony seam
 * @param tokenStorage トークン書込先 (未注入時は書込スキップ)
 * @param input `{ mediation? }`
 */
export async function signInWithPasskey(apiClient, webAuthnBridge, tokenStorage, input) {
    const options = await apiClient.post("/auth/passkey/signin-options", {});
    // Conditional UI silent-degrade (Req 11.6): `mediation:"conditional"` を要求しても
    // 実行環境が Conditional UI 非対応なら、throw せず `"optional"` に degrade する。
    const mediation = await resolveMediation(input?.mediation);
    const assertion = await webAuthnBridge.get(options, mediation);
    const loginResponse = await apiClient.post("/auth/passkey/signin-verify", {
        challengeToken: options.challengeToken,
        assertion,
    });
    // password login と同様、既存 TokenStorage に書込む (Req 11.3)。
    tokenStorage?.setTokens(loginResponse.access_token, loginResponse.refresh_token);
    return loginResponse;
}
/**
 * bridge に渡す mediation を解決する (Req 11.6 silent-degrade)。
 *
 * `"conditional"` 要求時のみ Conditional UI サポートを feature-detect し、
 * 非対応なら `"optional"` へ silent degrade する (error を投げない)。
 * 非 conditional な mediation はそのまま透過する。
 */
async function resolveMediation(mediation) {
    if (mediation !== "conditional") {
        return mediation;
    }
    const conditionalSupported = await detectConditionalMediationSupport();
    return conditionalSupported ? "conditional" : "optional";
}
//# sourceMappingURL=signin-ceremony.js.map